import React from 'react';
import { Menu, MenuItem, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';

interface Props {
  anchorEl: HTMLElement | null;
  menuOpen: boolean;

  handleOpenEditTagDialog(): void;
  handleOpenDeleteTagDialog(): void;
  handleCloseMenu(): void;
}

const TagItemMenu: React.FC<Props> = ({
  anchorEl,
  menuOpen,
  handleOpenEditTagDialog,
  handleOpenDeleteTagDialog,
  handleCloseMenu
}) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  return (
    <Menu
      anchorEl={anchorEl}
      open={menuOpen}
      onClose={handleCloseMenu}
      classes={{
        list: classes.menuList,
        paper: classes.menuPaper
      }}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      slotProps={{ paper: { style: { width: 'auto' } } }}
      disableEnforceFocus
      disableAutoFocus
      disableAutoFocusItem
      disableRestoreFocus
    >
      {/* Rename Tag */}
      <MenuItem
        className={classes.menuItem}
        onClick={() => {
          handleOpenEditTagDialog();
          handleCloseMenu();
        }}
      >
        <Typography className={classes.menuItemText}>
          {t('renameTag')}
        </Typography>
      </MenuItem>

      {/* Delete Tag */}
      <MenuItem
        className={classes.menuItem}
        onClick={() => {
          handleOpenDeleteTagDialog();
          handleCloseMenu();
        }}
      >
        <Typography className={cx(classes.menuItemText, 'delete')}>
          {t('delete')}
        </Typography>
      </MenuItem>
    </Menu>
  );
};

const useStyles = makeStyles()((theme) => ({
  menuPaper: {
    borderRadius: '6px', // Adjust to match your new design radius
    boxShadow: theme.shadows[3], // Subtle shadow or override as needed
    minWidth: '120px',
    backgroundColor: '#FFF'
  },
  menuList: {
    padding: 0
  },
  menuItem: {
    fontSize: theme.typography.pxToRem(13),
    padding: '8px 16px',
    borderBottom: `1px solid ${theme.palette.greys.light}`,
    '&:last-of-type': {
      borderBottom: 'none'
    },
    '&:hover': {
      background: theme.palette.action.hover
    }
  },
  menuItemText: {
    fontSize: theme.typography.pxToRem(13),
    '&.delete': {
      color: theme.palette.error.main
    }
  }
}));

export default TagItemMenu;
